var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ]
    },
    [
      _c(
        "el-row",
        {
          staticStyle: {
            height: "30px",
            display: "flex",
            "justify-content": "space-between",
            "align-items": "center"
          }
        },
        [
          _c("el-col", { attrs: { span: 18 } }, [
            _vm._v(" 代采计划单号" + _vm._s(_vm.$route.params.id) + " ")
          ]),
          _vm._v(" "),
          _c(
            "el-col",
            { staticStyle: { "text-align": "right" }, attrs: { span: 6 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.cancelFulfillmentStatistics }
                },
                [_vm._v("取消履约统计")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "blockinfo" },
        [
          _c(
            "div",
            { staticStyle: { height: "50px", "line-height": "50px" } },
            [_vm._v("代采计划单信息")]
          ),
          _vm._v(" "),
          _vm.resData
            ? _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("申请人：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.resData.admin_name))
                              ])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("市场：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.resData.market_name))
                              ])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("生成方式：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.resData.ptype_txt))
                              ]),
                              _vm._v(" "),
                              _vm.resData.is_dispense === "1"
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "12px",
                                        color: "blue"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              (小店分发)\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("商家：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.resData.supply_name))
                              ])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("代采员：")]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.resData.m_name))])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("代采类型：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.resData.plan_type))
                              ])
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("提交时间：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.resData.create_time))
                              ])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("审核时间：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.resData.wp_check_time))
                              ])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("需求日期：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.resData.wp_demanded_date))
                              ])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.resData.stocking_id > 0
                        ? _c(
                            "el-row",
                            [
                              _c("el-col", { attrs: { span: 24 } }, [
                                _c("div", { staticClass: "info-row" }, [
                                  _c("span", [_vm._v("备货单号：")]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.resData.stocking_id))
                                  ])
                                ])
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "margin-bottom": "20px" } },
        [
          _c("div", { staticClass: "card-title" }, [
            _vm._v(
              "\n      代采计划商品：计划代采共" +
                _vm._s(_vm.resData && _vm.resData.plan_num) +
                "件，计" +
                _vm._s(_vm.resData && _vm.resData.plan_price_total) +
                "\n\n      "
            )
          ]),
          _vm._v(" "),
          _vm.resData
            ? _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.resData.plan_goods,
                    border: "",
                    height: "400"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "序号", type: "index", align: "center" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "goods_kh",
                      label: "商品款号",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "goods_no",
                      label: "商品货号",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "goods_name",
                      label: "商品名称",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "goods_label",
                      label: "入仓标签",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "brand_name",
                      label: "品牌",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "goods_img",
                      label: "商品图片",
                      align: "center"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  directives: [
                                    { name: "viewer", rawName: "v-viewer" }
                                  ],
                                  staticStyle: {
                                    width: "40px",
                                    height: "40px",
                                    overflow: "hidden",
                                    cursor: "pointer",
                                    display: "inline-block"
                                  }
                                },
                                [
                                  _c("img", {
                                    staticStyle: {
                                      width: "100%",
                                      height: "100%"
                                    },
                                    attrs: { src: scope.row.goods_img }
                                  })
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      816305577
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "co_val",
                      label: "商品颜色",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "si_val",
                      label: "商品尺码",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "plan_price",
                      label: "代采单价",
                      align: "center",
                      width: "150px"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm.resData.plan_type_id ===
                                _vm.PLAN_TYPE.UP_FLOW_PLAN &&
                              _vm.resData.status ===
                                _vm.REVIEW_STATUS.PENDING_REVIEW
                                ? _c("ys-input", {
                                    attrs: { min: 0, pattern: "money" },
                                    on: {
                                      change: function($event) {
                                        return _vm.handlePlanPriceEdit(
                                          scope.row.plan_info_id,
                                          scope.row.plan_price
                                        )
                                      }
                                    },
                                    model: {
                                      value: scope.row.plan_price,
                                      callback: function($$v) {
                                        _vm.$set(scope.row, "plan_price", $$v)
                                      },
                                      expression: "scope.row.plan_price"
                                    }
                                  })
                                : _c("div", [
                                    _vm._v(_vm._s(scope.row.plan_price))
                                  ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      908101262
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "plan_num",
                      label: "代采数量",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "wait_order_num",
                      label: "待开单",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "wait_cancel_num",
                      label: "急救箱",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "cancel_num",
                      label: "已断货",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "finance_wait_confirm_num",
                      label: "财务待审核",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "ok_num", label: "已完成", align: "center" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "plan_price_total",
                      label: "计划代采金额",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "ok_price_total",
                      label: "财务已支付",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "pg_name", label: "买手组", align: "center" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "pgname", label: "代采组", align: "center" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "delivery_day",
                      label: "货期",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "delivery_time_txt",
                      label: "承诺发货日期",
                      align: "center"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      align: "center",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.gl_supply_id != _vm.resData.supply_id &&
                              scope.row.info_status == 1
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function($event) {
                                          return _vm.moveOutPurchasePlan(
                                            scope.row
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("迁出代采计划")]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2289967621
                    )
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", [
        _c(
          "div",
          { staticClass: "remarks", staticStyle: { "margin-bottom": "16px" } },
          [
            _c(
              "div",
              { staticClass: "title", staticStyle: { "margin-bottom": "8px" } },
              [_vm._v("创建备注")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "content",
                staticStyle: {
                  padding: "8px 16px",
                  background: "#eee",
                  "border-radius": "4px",
                  "max-height": "180px",
                  "overflow-y": "auto"
                }
              },
              [_vm._v("\n        " + _vm._s(_vm.resData.remarks) + "\n      ")]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { "padding-bottom": "300px" } },
          [
            _c(
              "div",
              { staticClass: "title", staticStyle: { "margin-bottom": "8px" } },
              [_vm._v("审核备注")]
            ),
            _vm._v(" "),
            _c("el-input", {
              attrs: { type: "textarea", rows: 2, placeholder: "请输入内容" },
              model: {
                value: _vm.textarea,
                callback: function($$v) {
                  _vm.textarea = $$v
                },
                expression: "textarea"
              }
            }),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  {
                    staticStyle: { "text-align": "right", "margin-top": "20px" }
                  },
                  [
                    _vm.resData.status == 11
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "small" },
                            on: {
                              click: function($event) {
                                return _vm.updateCheck(1)
                              }
                            }
                          },
                          [_vm._v("审核通过")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.resData.status == 11
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "small" },
                            on: {
                              click: function($event) {
                                return _vm.updateCheck(0)
                              }
                            }
                          },
                          [_vm._v("驳回")]
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52627642", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52627642","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PurchasePlanDetail.vue
// module id = null
// module chunks = 